import { Component, NgZone, ViewChild } from '@angular/core';
import { Events, NavController, Modal } from 'ionic-angular';
import { Http } from '@angular/http';
import { AUTOCOMPLETE_DIRECTIVES } from 'ionic2-auto-complete';

import { ProjectPage } from '../project/project';
import { MoreModal } from '../more/more';
import { AutoComplete } from '../../services/autocomplet';

import { DOMAIN } from '../../config';

import * as L from 'leaflet';
import * as moment from 'moment';

@Component({
  selector: 'page-home',
  templateUrl: 'build/pages/home/home.html',
  directives: [AUTOCOMPLETE_DIRECTIVES],
  providers: [AutoComplete]
})

export class HomePage {
  @ViewChild('searchGare')
  private searchGare: any;
  private os: any;
  private slidersOptions: any = Object;
  private categories: any = Array;
  private projects: any = Array;
  private week: any = Array;
  private weeks: any = Array;
  private ters: any = Array;
  private tersSaveList: any = Array;
  private gares: any = Array;
  private selectedGare: any = Array;
  private geojsons: any = Array;
  private map: any = Array;
  private selectedWeek: any = Array;
  private selectedTer: any = Array;

  constructor(private http: Http, private events: Events, public nav: NavController, private zone: NgZone, private autocomplete: AutoComplete) {
    this.categories = [];
    this.projects = [];
    this.week = null;
    this.weeks = [];
    this.ters = [];
    this.tersSaveList = [];
    this.os = null;

    this.selectedGare = null;
    this.gares = null;

    this.geojsons = [];
    this.selectedWeek = null;
    this.selectedTer = 'all';
    this.map;

    this.slidersOptions = {
      pager: true,
      onlyExternal: true
    };

    this.http
      .get(`//${DOMAIN}/api/ters`)
      .map(res => res.json())
      .subscribe(data => {
        for (let ter of data) {
          this.ters.push(ter);
        }
        this.tersSaveList = this.ters;
    });

    if (navigator.appVersion.indexOf("Android")!== -1) {
      this.os = 'android';
    }
  }

  ngAfterViewInit() {
    if (this.os === 'android') {
      (<HTMLElement> document.querySelector('.first')).style.width = '105%';
      (<HTMLElement> document.querySelector('.first')).style.marginLeft = '-3%';
    } else {
      (<HTMLElement> document.querySelector('.first')).style.width = '108%';
      (<HTMLElement> document.querySelector('.first')).style.marginLeft = '-4%';
    }
    //ionViewDidEnter() {
    // Leaflet Map Init
    let mapDiv = document.querySelector('.map') as HTMLElement;
    mapDiv.style.height = window.innerHeight * 0.1 + 'px';

    let tiles = {
      map: `//${DOMAIN}/api/tiles/sncf_fond/{z}/{x}/{y}`,
      typos: `//${DOMAIN}/api/tiles/sncf_typos/{z}/{x}/{y}`,
      symboles: `//${DOMAIN}/api/tiles/sncf_symboles/{z}/{x}/{y}`
    };

    L.Icon.Default.imagePath = `https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.0.3/images/`;
    this.map = L.map((mapDiv), {
      zoomControl: false,
      maxBounds: [
        [42.9403, 1.4392],
        [47.8721, 7.7343]
      ]
    }).setView([45.508022, 4.744426], 7);

    L.control.zoom({
      position: 'topright'
    }).addTo(this.map);

    this.map.touchZoom.disable();

    L.tileLayer(tiles.map, {
      maxZoom: 12,
      minZoom: 6
    }).addTo(this.map);

    L.tileLayer(tiles.symboles, {
      maxZoom: 12,
      minZoom: 6,
      zIndex: 2
    }).addTo(this.map);

    let typos = L.tileLayer(tiles.typos, {
      maxZoom: 12,
      minZoom: 6,
      zIndex: 3
    }).addTo(this.map);

    // Create a new container for the typo tiles
    let topPane = this.map._createPane('leaflet-top-pane', this.map.getPanes().mapPane);
    topPane.appendChild(typos.getContainer());
    typos.setZIndex(5);

    if (window.innerHeight > 700) {
      (<HTMLElement> document.querySelector('.home')).style.height = '237%';
    } else if (window.innerHeight > 600 && window.innerHeight < 700) {
      (<HTMLElement> document.querySelector('.home')).style.height = '227%';
    } else {
      (<HTMLElement> document.querySelector('.home')).style.height = '183%';
    }

    /*
    // On récupère la liste des catégorie
    this.http
      .get(`//${DOMAIN}/api/categories`)
      .map(res => res.json())
      .subscribe(data => {
        for (let categorie of data) {
          this.categories.push(categorie);
        }
      });

    // Bouton de la légende
    let Legend = L.Control.extend({
      options: {
        position: 'topright'
      },
      onAdd: function(map) {
        let container = L.DomUtil.create('div', 'legend-control');
        let span = L.DomUtil.create('span', 'tooltip');
        container.appendChild(span);
        container.style.backgroundImage = "url('/img/legend.png')";
        container.style.backgroundColor = "white";
        container.style.backgroundRepeat = "no-repeat";
        container.style.backgroundPosition = "center center";
        container.style.backgroundSize = '100%';
        container.style.width = '30px';
        container.style.height = '30px';
        container.style.boxShadow = '0 1px 5px rgba(0, 0, 0, 0.65)';
        container.style.borderRadius = '4px';
        container.style.cursor = 'pointer';
        let legend = <HTMLElement>document.querySelector('.legend');

        L.DomEvent.disableClickPropagation(container);

        L.DomEvent.addListener(container, 'click', (e) => {
          if (legend.style.display === 'none' || !legend.style.display) {
            legend.style.display = 'block';
          } else {
            legend.style.display = 'none';
          }
        });

        return container;
      }
    });

    this.map.addControl(new Legend());
    */
    // Tableau de toutes les semaines dispo
    let min = {
      year: 2017,
      month: 12,
      day: 11
    };
    let date = new Date(min.year, min.month - 1, min.day);
    let firstMin = moment(date).week();
    let secondMin = moment(date).weeksInYear();

    let max = {
      year: 2018,
      month: 12,
      day: 19
    };
    date = new Date(max.year, max.month - 1, max.day);
    let secondMax = moment(date).weeksInYear();

    this.getWeeks(firstMin, secondMin, min.year);
    this.getWeeks(1, secondMax, max.year);

    // Récupérer la semaine en cours
    this.week = moment().format('W');
    let year = moment().format('Y');

    // on affiche en premier la week en cours dans le tableau de week
    let indexWeek = null;
    for(var i = 0; i < this.weeks.length; i++) {
       if (this.weeks[i].number === +this.week && this.weeks[i].year === +year) {
         indexWeek = i;
       }
    }

    let tab1 = this.weeks.slice(indexWeek, this.weeks.length);
    let tab2 = this.weeks.slice(0, indexWeek);

    this.weeks = [];
    this.weeks = tab1.concat(tab2);

    setTimeout(() => {
      this.loadGTFS(this.week, 'all', null);
      this.map.on('zoomend', () => {
        for (let geojson of this.geojsons) {
          for (let layer of geojson.getLayers()) {
            if (this.map.getZoom() > 8) {
              if (layer.feature.geometry.type === 'Point' && layer.feature.properties.type === 'center') {
                this.map.removeLayer(layer);
              } else {
                layer.addTo(this.map);
              }
            } else {
              if (layer.feature.geometry.type === 'Point' && layer.feature.properties.type === 'center') {
                layer.addTo(this.map);
              } else {
                this.map.removeLayer(layer);
              }
            }
          }
        }
      });

      setInterval( () => {
        let inputValue = this.searchGare.getValue();
        if (inputValue === '' || inputValue === null) {
          this.ters = this.tersSaveList;
        }
      }, 300);

      this.map.invalidateSize();
    }, 120)
  }

  loadGTFS(week, ter, gare) {
    if (this.geojsons.length !== 0) {
      // Supprimer tous les layers
      for (let geojson of this.geojsons) {
        for (let layer of geojson.getLayers()) {
          this.map.removeLayer(layer);
        }
      }
    }

    if (this.projects.length !== 0) {
      this.projects = [];
    }

    this.geojsons = [];
    // Charger les GTFS
    this.zone.run(() => {
      let request;

      if (week !== 'all' && ter !== 'all' && gare === null) {
        request = `//${DOMAIN}/api/projects/ters/${ter}/${week}`;
      } else if (week === 'all' && ter !== 'all' && gare === null) {
        request = `//${DOMAIN}/api/projects/ters/${ter}`;
      } else if (week === 'all' && ter === 'all' && gare === null) {
        request = `//${DOMAIN}/api/projects/week/${this.week}`;
      } else if (week !== 'all' && ter !== 'all' && gare !== null) {
        request = `//${DOMAIN}/api/projects/ters/${ter}/${week}`;
      } else if (week === 'all' && ter !== 'allSA' && gare !== null) {
        request = `//${DOMAIN}/api/projects/ters/${ter}`;
      } else if (week !== 'all' && ter === 'allSA' && gare !== null) {
        request = `//${DOMAIN}/api/projects/week/${this.week}/gare/${gare}`;
      } else if (week === 'all' && ter === 'allSA' && gare !== null) {
        request = `//${DOMAIN}/api/projects/gare/${gare}`;
      } else {
        request = `//${DOMAIN}/api/projects/week/${week}`;
      }

      this.http
        .get(request)
        .map(res => res.json())
        .subscribe(data => {

          for (let project of data) {
            /*
            if (project.couleur === '#f5d100' ) {
              project.textColor = '#000';
            } else {
              project.textColor = '#fff';
            }
            */
            project.textColor = '#fff';

            // On récupère le nom de la catégorie
            this.http
              .get(`//${DOMAIN}/api/categories`)
              .map(resCat => resCat.json())
              .subscribe(dataCat => {
                for (let categorie of dataCat) {
                  if (project.categorie === categorie.id) {
                    project.nomCat = categorie.nom;
                  }
                }
            });

            // On charge les geojson des projets à afficher
            let ids = [];
            if (project.id) {
              ids.push(project.id);
            } else {
              ids = project.chantiers;
            }

            for (let id of ids) {
              this.http
                .get(`//${DOMAIN}/api/geojson/${id}`)
                .map(res => res.json())
                .subscribe(data => {
                  var marker = {
                    radius: 8,
                    fillColor: project.couleur,
                    color: '#fff',
                    stroke: true,
                    weight: 2,
                    opacity: 1,
                    fillOpacity: 1,
                    className: 'path' + id
                  };

                  var markerClick = {
                    radius: 11,
                    fillColor: project.couleur,
                    color: '#000',
                    stroke: true,
                    weight: 2.5,
                    opacity: 0,
                    fillOpacity: 0,
                    className: 'path' + id
                  };

                  for (let feature of data.features) {
                    if (feature.properties.type !== 'CP') {
                      let line = new L.GeoJSON(feature, {
                        // Pour les lignes on leur donne la couleur
                        style: function(feature) {
                          if (feature.geometry.type !== 'Point') {
                            return {
                              color: project.couleur,
                              opacity: 1,
                              className: 'path' + id
                            };
                          }
                        },
                        // Pour les points
                        pointToLayer: (feature, latlng) => {
                          return L.circleMarker(latlng, marker);
                        }
                      });
                      this.geojsons.push(line);

                      let lineClik = new L.GeoJSON(feature, {
                        // Pour les lignes on leur donne la couleur
                        style: function(feature) {
                          if (feature.geometry.type !== 'Point') {
                            return {
                              opacity: 0,
                              weight: 15,
                              className: 'path' + id
                            };
                          }
                        },
                        // Pour les points
                        pointToLayer: (feature, latlng) => {
                          return L.circleMarker(latlng, markerClick);
                        }
                      });
                      this.geojsons.push(lineClik);

                      if (this.map.getZoom() > 8) {
                        if (feature.geometry.type !== 'Point' && feature.properties.type !== 'center') {
                          this.map.addLayer(line);
                          this.map.addLayer(lineClik);
                        }
                      } else {
                        if (feature.geometry.type === 'Point' && feature.properties.type === 'center') {
                          this.map.addLayer(line);
                          this.map.addLayer(lineClik);
                        }
                      }

                      lineClik.on('click', event => {
                        this.nav.push(ProjectPage, {
                          project: project
                        });
                        //this.map.remove();
                      });
                    }
                  }
              });
            }
            this.projects.push(project);
          }
        });
    });
  }

  clickSlide(event) {
    this.nav.push(ProjectPage, {
      project: event
    });
    //this.map.remove();
  }

  gareSelected(event) {
    let select = this.searchGare.getValue();
    if (select !== '' || select !== null) {
      this.selectedGare = event.ters;

      let tersIntermediate = [];

      this.tersSaveList.forEach((line)=>{
          if (event.ters.split(",").includes(line.id)) {
              tersIntermediate.push(line);
          }
      });
      this.ters = tersIntermediate;
    }
  }

  choiceTER(ter) {
    if (ter === 'Tout le réseau') {
      this.selectedTer = 'all';
      this.map.setView([45.308022, 4.744426], 7);
    } else if (ter === 'Tous les axes passant par cette gare') {
      this.selectedTer = 'allSA';
      this.map.setView([45.308022, 4.744426], 7);
    } else {
      this.selectedTer = ter.split(":")[0];
      // On zoom sur le TER
      this.http
        .get(`//${DOMAIN}/api/ters`)
        .map(res => res.json())
        .subscribe(data => {
          for (let ter of data) {
            if (ter.id === this.selectedTer) {
              if (ter.coords) {
              let coords = ter.coords.split(",");
              let bounds = L.latLngBounds(L.latLng(coords[0], coords[1]), L.latLng(coords[2], coords[3]));

              this.map.fitBounds(bounds, {
                  maxZoom: 13
              });
          }
            }
          }
        });
    }

    if (this.selectedWeek) {
      this.loadGTFS(this.selectedWeek, this.selectedTer, this.selectedGare);
    } else {
      this.loadGTFS(this.week, this.selectedTer, this.selectedGare);
    }
  }

  choiceWeek(week) {
    this.selectedWeek = 'all';
    if (week !== 'Tout le SA 2018') {
      for(var i = 0; i < this.weeks.length; i++) {
         if (this.weeks[i].text === week) {
           this.selectedWeek = this.weeks[i].number;
         }
      }
    }

    if (this.selectedTer) {
      this.loadGTFS(this.selectedWeek, this.selectedTer, this.selectedGare);
    } else {
      this.loadGTFS(this.week, this.ters, this.selectedGare);
    }
  }

  getWeeks(min, max, year) {
    for (let i = min; i <= max; ++i) {
      let first = moment().year(year).week(i).day(1);
      let last = moment().year(year).week(i).day(7);

      let week = {
          number: i,
          year: year,
          text: `Semaine ${i} du ${first.format('DD/MM/YY')} au ${last.format('DD/MM/YY')}`
      };

      // Try if the current week is at this index
      if ((moment().isAfter(first) || moment().isSame(first)) &&
          (moment().isSame(last) || moment().isBefore(last))) {
          this.week = week;
      }

      this.weeks.push(week);
    }
  }

  more() {
    this.nav.present(Modal.create(MoreModal));
  }
}
